export default "__VITE_ASSET__YEmwdMkc__"